export default function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}


//////////////////
// WEBPACK FOOTER
// /home/riforce/domains/riforce.nl/releases/20250205091926/node_modules/swiper/esm/components/core/translate/maxTranslate.js
// module id = 122
// module chunks = 0